export default "__VITE_ASSET__BZZpEA2Z__"